"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailValuePrice = exports.DetailValue = exports.DetailKey = exports.Detail = exports.SectionContents = exports.SectionHeading = exports.Section = exports.SectionPanel = void 0;
var React = require("react");
var SectionPanel = function (_a) {
    var className = _a.className, id = _a.id, key = _a.key, children = _a.children;
    return (React.createElement("div", { key: "".concat(key || ""), id: "".concat(id || ""), className: "section-panel ".concat(className || "") }, children));
};
exports.SectionPanel = SectionPanel;
var Section = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "section ".concat(className || "") }, children));
};
exports.Section = Section;
var SectionHeading = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "section-heading text-blue-green font-weight-semi-bold ".concat(className || "") }, children));
};
exports.SectionHeading = SectionHeading;
var SectionContents = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "section-contents ".concat(className || "") }, children));
};
exports.SectionContents = SectionContents;
var Detail = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "detail ".concat(className || "") }, children));
};
exports.Detail = Detail;
var DetailKey = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "detail-key ".concat(className || "") }, children));
};
exports.DetailKey = DetailKey;
var DetailValue = function (_a) {
    var className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "detail-value ".concat(className || "") }, children));
};
exports.DetailValue = DetailValue;
var DetailValuePrice = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { className: "detail-value font-weight-semi-bold text-blue-1" }, children));
};
exports.DetailValuePrice = DetailValuePrice;
//# sourceMappingURL=SectionPanelTags.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/SectionPanelTags.js
// module id = 1384
// module chunks = 0